import { Toc } from 'components/Toc';
import useGenerateToc from 'hooks/useGenerateToc';
import React from 'react';
import styled from 'styled-components';
import MarkdownRenderer from 'utils/MarkdownRenderer';

type DocsLayoutProps = {
  content: string | undefined;
};

const DocsLayout: React.FC<DocsLayoutProps> = ({ content }) => {
  const markdownRef = React.useRef<HTMLDivElement>(null);
  const tocItems = useGenerateToc(markdownRef, content);

  return (
    <StyledContainer>
      <ContentArea className="markdown-container" ref={markdownRef}>
        <MarkdownRenderer>{content || ''}</MarkdownRenderer>
      </ContentArea>
      {tocItems.length > 0 && (
        <Sidebar className="toc-container">
          <Toc items={tocItems} />
        </Sidebar>
      )}
    </StyledContainer>
  );
};

export default DocsLayout;

export const StyledContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 45px;

  width: 100%;
  margin-bottom: 80px;
`;

const ContentArea = styled.div`
  max-width: 769px;
  flex: 1;
  line-height: 1.6;
  font-size: 16px;
  overflow-x: auto;
  margin-bottom: 480px;
`;

const Sidebar = styled.div`
  width: 275px;
  position: sticky;
  top: 0px;
`;
